"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
class HttpService {
    /**
     *
     * @param baseURL base URL for the API
     * @param cacheDuration cache duration in seconds
     */
    constructor(baseURL, cacheDuration = 5 * 60) {
        this.entitlerPost = (endpoint, body, apiKey) => __awaiter(this, void 0, void 0, function* () {
            const fullUrl = `${this.baseURL}${endpoint}`;
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("X-Api-Key", apiKey);
            const raw = JSON.stringify(body);
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            try {
                const response = yield fetch(fullUrl, requestOptions);
                if (!response.ok) {
                    //console.log("Not Ok");
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = yield response.json();
                return data.jwt;
            }
            catch (error) {
                //console.log("catch", error);
                throw error;
                //return null;
            }
        });
        this.baseURL = baseURL;
        this.cacheDuration = cacheDuration * 1000;
        //console.log("cacheDuration", this.cacheDuration);
    }
    get(endpoint, cachekey, apiKey, init) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullUrl = `${this.baseURL}${endpoint}`;
            const key = (cachekey) ? cachekey : fullUrl;
            const cachedData = this.getFromCache(key);
            if (cachedData) {
                return cachedData;
            }
            const myHeaders = new Headers();
            if (apiKey) {
                myHeaders.append("X-Api-Key", apiKey);
            }
            const response = yield fetch(fullUrl, Object.assign({ headers: myHeaders, method: 'GET' }, init));
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            this.saveToCache(key, data);
            return data;
        });
    }
    entitlerPost2(endpoint_1, body_1, apiKey_1) {
        return __awaiter(this, arguments, void 0, function* (endpoint, body, apiKey, method = 'POST') {
            var _a, _b, _c;
            try {
                const fullUrl = `${this.baseURL}${endpoint}`;
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("X-Api-Key", apiKey);
                const res = yield fetch(fullUrl, {
                    method,
                    headers: myHeaders,
                    body: JSON.stringify(body),
                    redirect: "follow"
                });
                //const payload: ServerResponse<T> = await res.json();
                const data = yield res.json();
                if (!res.ok) {
                    // assume payload is already your Auth0ServerErrorResponse
                    return {
                        success: false, error: {
                            error: "EntitlerError",
                            description: res.statusText,
                            message: "There was a server issue. Please try again later.",
                            code: "ENT_SRV_ERR"
                        }
                    };
                }
                let fixedData;
                if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.body) {
                    fixedData = data.data.body;
                }
                else if (data === null || data === void 0 ? void 0 : data.data) {
                    fixedData = data.data;
                }
                else {
                    fixedData = data;
                }
                //return payload;
                return { success: true, data: fixedData };
            }
            catch (err) {
                // here’s the generic error‐mapper:
                return {
                    success: false,
                    error: {
                        error: (_b = err.name) !== null && _b !== void 0 ? _b : "FetchError",
                        description: (_c = err.message) !== null && _c !== void 0 ? _c : String(err),
                        message: "There was a server issue. Please try again later.",
                        code: "SRV_ERR"
                    },
                };
            }
        });
    }
    parseBodyAsJsonOrText(body) {
        const trimmed = body.trim();
        if (!trimmed) {
            return {};
        }
        try {
            return JSON.parse(trimmed);
        }
        catch (_a) {
            return trimmed;
        }
    }
    post(endpoint, body, apiKey, init) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullUrl = `${this.baseURL}${endpoint}`;
            const myHeaders = new Headers();
            //myHeaders.append("Content-Type", "application/json");
            if (apiKey) {
                myHeaders.append("X-Api-Key", apiKey);
            }
            try {
                const response = yield fetch(fullUrl, Object.assign({ method: 'POST', headers: myHeaders, mode: 'cors', body: JSON.stringify(body) }, init));
                const text = yield response.text();
                if (!response.ok) {
                    const hint = text ? `: ${text.slice(0, 200)}` : '';
                    throw new Error(`HTTP error! status: ${response.status}${hint}`);
                }
                return this.parseBodyAsJsonOrText(text);
            }
            catch (error) {
                throw error;
            }
        });
    }
    // testing using this. Main difference is it will always return a ServerResponse so that I don't need to have a catch in my api calls. I just need to check success flag.
    post2(endpoint, body, apiKey) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const fullUrl = `${this.baseURL}${endpoint}`;
                const myHeaders = new Headers();
                if (apiKey) {
                    myHeaders.append("X-Api-Key", apiKey);
                }
                const res = yield fetch(fullUrl, {
                    method: 'POST',
                    headers: myHeaders,
                    mode: 'cors',
                    body: JSON.stringify(body)
                });
                const payload = yield res.json();
                if (!res.ok) {
                    // assume payload is already your Auth0ServerErrorResponse
                    return { success: false, error: payload.error };
                }
                if (payload.success !== false)
                    payload.success = true;
                return payload;
                //return { success: true, data: payload as T };
            }
            catch (err) {
                // here’s the generic error‐mapper:
                return {
                    success: false,
                    error: {
                        error: (_a = err.name) !== null && _a !== void 0 ? _a : "FetchError",
                        description: (_b = err.message) !== null && _b !== void 0 ? _b : String(err),
                        message: "There was a server issue. Please try again later.",
                        code: "SRV_ERR"
                    },
                };
            }
        });
    }
    getFromCache(url) {
        const cachedEntry = localStorage.getItem(url);
        if (!cachedEntry) {
            return null;
        }
        try {
            const { data, timestamp } = JSON.parse(cachedEntry);
            const isExpired = Date.now() - timestamp > this.cacheDuration;
            if (isExpired) {
                localStorage.removeItem(url); // Remove expired cache
                return null;
            }
            return data;
        }
        catch (error) {
            console.error("Error parsing cache data:", error);
            localStorage.removeItem(url); // Clear corrupt cache
            return null;
        }
    }
    saveToCache(url, data) {
        const ts = Date.now() + this.cacheDuration;
        const expirationString = new Date(ts).toLocaleString();
        const cacheEntry = {
            data,
            timestamp: ts,
            expirationString
        };
        localStorage.setItem(url, JSON.stringify(cacheEntry));
    }
    clearCache(url) {
        if (url) {
            localStorage.removeItem(url);
        }
        else {
            localStorage.clear();
        }
    }
    delete(endpoint, apiKey, init) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullUrl = `${this.baseURL}${endpoint}`;
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            if (apiKey) {
                myHeaders.append("X-Api-Key", apiKey);
            }
            try {
                const response = yield fetch(fullUrl, Object.assign({ method: 'DELETE', headers: myHeaders }, init));
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                if (response.status === 204) {
                    return {};
                }
                const text = yield response.text();
                return this.parseBodyAsJsonOrText(text);
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.HttpService = HttpService;
